module.exports = "<app-header  ></app-header>\n<app-routing-component></app-routing-component> \n\n<app-footer></app-footer>"